import { defineStyleConfig } from '@chakra-ui/react';

export const formLabelTheme = defineStyleConfig({
  baseStyle: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 'medium',
    color: 'fonts.primary',
    mb: '2',
  },
});
